import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoSolicitacao } from './indicacao.types';

export const postIndicacaoSolicitacao = async (observacao?: string) => {
	try {
		const response = await BaseClient.post<IndicacaoApiResponse<IndicacaoSolicitacao>>(
			'v2/Indicacao/Solicitacao',
			{ observacao: observacao ?? null }
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoSolicitacao>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
